exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".menu{background-color:#fff}.menu .menu-inner{padding:3em 0;display:block}.menu .menu-inner .brand{display:block;width:100%;height:30px;text-indent:-99999999px;outline:none;overflow:hidden;background-image:url(\"/static/iloyalty.png\");background-size:contain;background-repeat:no-repeat;background-position:top}.menu .menu-inner ul.navigation{margin-top:4em;padding:0;display:block;list-style:none}.menu .menu-inner ul.navigation>li{display:block;width:100%;height:60px;line-height:60px}.menu .menu-inner ul.navigation>li>a{display:block;margin-left:3em;border-bottom:1px solid #eee;color:#666;font-weight:100}.menu .menu-inner ul.navigation>li>a>i{margin-right:10px}.menu .menu-inner ul.navigation>li>a.active,.menu .menu-inner ul.navigation>li>a:hover{color:#222;font-weight:400;text-decoration:none}.menu .menu-inner ul.navigation>li>a.active>i,.menu .menu-inner ul.navigation>li>a:hover>i{color:#a3cc0e}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/postcss-loader!../~/stylus-loader!./ui/side_menu/styles.styl
// module id = 951
// module chunks = 0